
import React from "react";
import { MonitorPlay, ImageIcon, Percent } from "lucide-react";
import StatCard from "@/components/common/StatCard";

interface DashboardStatsProps {
  screensCount: number;
  adsCount: number;
  averageOccupancy: number;
}

const DashboardStats: React.FC<DashboardStatsProps> = ({
  screensCount,
  adsCount,
  averageOccupancy,
}) => (
  <div className="space-y-4">
    <h3 className="text-lg font-medium">Estadísticas generales</h3>
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <StatCard
        title="Pantallas totales"
        value={screensCount}
        icon={<MonitorPlay size={24} className="text-outdoor-700" />}
      />
      <StatCard
        title="Anuncios activos"
        value={adsCount}
        icon={<ImageIcon size={24} className="text-green-500" />}
      />
      <StatCard
        title="Ocupación promedio"
        value={`${averageOccupancy}%`}
        icon={<Percent size={24} className="text-amber-500" />}
      />
    </div>
  </div>
);

export default DashboardStats;
